export default "__VITE_ASSET__DPzAY_Wl__"